"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownItemBorderPosition = void 0;
// TODO: remove in 3.0
var DropdownItemBorderPosition;
exports.DropdownItemBorderPosition = DropdownItemBorderPosition;

(function (DropdownItemBorderPosition) {
  DropdownItemBorderPosition[DropdownItemBorderPosition["Top"] = 0] = "Top";
  DropdownItemBorderPosition[DropdownItemBorderPosition["Bottom"] = 1] = "Bottom";
})(DropdownItemBorderPosition || (exports.DropdownItemBorderPosition = DropdownItemBorderPosition = {}));